/* eslint-disable max-len */
import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.CountAndCompareGroups.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);
  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CountAndCompareGroups.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.instructions = null;
  this.choices = [];
};

EDC.Games.CountAndCompareGroups.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountAndCompareGroups.Scenes.Main.prototype.constructor = EDC.Games.CountAndCompareGroups.Scenes.Main;

const CGAC = EDC.Games.CountAndCompareGroups.Scenes.Main.prototype;

CGAC.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.adjustHitArea();
  this.loadIteration();

  this.createBasicUI();
};

CGAC.loadIteration = function () {
  this.addQuestion();
  this.createBoxes();
  // this.shakeToys();
};

CGAC.createTemplateUI = function () {
  let title;
  const { titleImg } = this.gameConfig;
  for (let i = 0; i < 3; i++) {
    this.add.sprite(400, 220 + i * 145, 'wood');
  }
  if (titleImg) {
    title = this.add.sprite(400, 300, 'title');
  } else {
    title = this.make.text({
      x: 70,
      y: 120,
      text: this.gameConfig.titleTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: '100px',
        wordWrap: { width: '730' },
        lineSpacing: 65,
      },
    });
  }
};

CGAC.adjustHitArea = function () {
  const rect = new Phaser.Geom.Rectangle(50, 700, 1800, 300);
  const hitArea = this.add.graphics({ fillStyle: { alpha: 0 } });
  hitArea.fillRectShape(rect);
  hitArea.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(hitArea);
};

CGAC.addQuestion = function () {
  const { instructions } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const instructionsImg = this.add.sprite(1200, 450, `instructions-${instructions}`);
  this.instructions = instructionsImg;
};

CGAC.createBoxes = function () {
  const { choices } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { answer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < choices.length; i++) {
    const container = this.add.container(0, 840);
    const shadow = this.add.sprite(0, 130, 'shadow');
    const box = this.add.sprite(0, 0, 'box');
    container.add(shadow);
    container.add(box);
    container.setSize(300, 250);
    container.choices = [];
    const positions = this.adjustPositionInContainer(choices[i]);
    for (let j = 0; j < choices[i].length; j++) {
      const choice = this.add.sprite(positions[j][0], positions[j][1], `choice-${choices[i][j]}`).setOrigin(0, 1);
      container.add(choice);
      container.choices.push(choice);
    }
    if (i === answer - 1) {
      container.isCorrect = true;
    }
    this.startShakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.choices.push(container);
  }
  this.adjustPosition(this.choices);
};

CGAC.checkAnswer = function (answer) {
  if (answer.isCorrect) {
    this.playCorrect();
    this.choices.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
      return true;
    });
    answer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2500, this.nextIteration, [], this);
  } else {
    answer.choices.map((x) => {
      x.setTint(0xff0000);
      return true;
    });
    answer.getAt(1).setTint(0xff0000);
    answer.shakeAnim.stop();
    answer.angle = 0;
    answer.disableInteractive();
    this.playWrong();
    answer.getData('markAnim').showMark(false, () => {});
  }
};

CGAC.nextIteration = function () {
  this.iteration = this.iteration + 1;
  this.instructions.destroy();
  this.instructions = null;
  this.choices.map((x) => {
    x.destroy();
    return true;
  });
  this.choices = [];
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

CGAC.adjustPositionInContainer = function (array) {
  const positions = [];
  const itemWidth = 75;
  const itemsPerRow = 5;
  const totalWidth = array.length > 5 ? itemsPerRow * itemWidth : array.length * itemWidth;
  const startingX = -totalWidth / 2 - 30;
  for (let i = 0; i < array.length; i++) {
    const x = startingX + itemWidth * (i % itemsPerRow);
    const y = 125 + Math.floor(i / itemsPerRow) * 100;
    positions.push([x, y]);
  }
  return positions;
};

CGAC.adjustPosition = function (array) {
  const width = array.length * array[0].displayWidth;
  const startingX = (this.game.config.width - width) / 2 - 75;
  for (let i = 0; i < array.length; i++) {
    array[i].x = startingX + (array[0].displayWidth + 175) * i;
    array[i].init_X = array[i].x;
  }
};

CGAC.wrongAnimation = function (box) {
  const toys = this.toyGroup[box.number];
  const boxSprite = this.boxSprite[box.number].setTint(0xff0000);
  toys.map((x) => {
    x.setTint(0xff0000);
    return true;
  });
  this.tweens.add({
    targets: boxSprite,
    x: boxSprite.x + 10,
    ease: 'Linear',
    duration: 50,
    repeat: 3,
    yoyo: true,
  });
  for (let i = 0; i < toys.length; i++) {
    this.tweens.add({
      targets: toys[i],
      x: toys[i].x + 10,
      ease: 'Linear',
      duration: 50,
      repeat: 3,
      yoyo: true,
    });
  }
};

CGAC.backToStart = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.startShakeAnimation.bind(this, choice),
  });
};

CGAC.startShakeAnimation = function (choice) {
  const repeats = 5;
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 1,
    ease: 'Linear',
    yoyo: false,
    delay: 6000,
    onActive: this.moveRight.bind(this, choice, repeats),
  });
};

CGAC.moveRight = function (choice, repeats) {
  repeats -= 1;
  if (repeats < 0) {
    this.backToStart(choice);
  } else {
    choice.shakeAnim = this.tweens.add({
      targets: choice,
      angle: 2,
      duration: 100,
      ease: 'Sine.easeInOut',
      yoyo: false,
      onComplete: this.moveLeft.bind(this, choice, repeats),
    });
  }
};

CGAC.moveLeft = function (choice, repeats) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: -2,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.moveRight.bind(this, choice, repeats),
  });
};

export default EDC.Games.CountAndCompareGroups.Scenes.Main;
